<template>
    
    <div class="container">
    
    <div class="level panel">
        <div class="level-center">
    
            <div class="field is-horizontal">
                <div class="field-label" style="white-space: nowrap"><label class="label">Справочник: </label>
                
                
                </div>             

                <div class="field-body">

                <div class="field"><div class="select">
                    <select v-model.number="selectedId" v-on:change="selectCatalog()">
                       <option value="1">ФСНТО2008</option>
                       <option value="2">Смета ТО по РТМ</option>
                       <option value="3">Прейскурант 2661 001-92</option>
                       <option value="4">МВД-2012</option>
                    </select>{{selectedId}}
                </div></div>

                    <div class="field is-expanded">
                        <div class="field is-horizontal ahas-addons">
                            <div class="control is-expanded" style="min-width: 200px"><input class="input is-primary" placeholder="Поиск" type="text" v-model="filterQuery" v-on:change="setFilter"/></div>
                            
                            <div class="field is-horizontal has-addons" style="margin-left: .6rem">
                                <div class="control"><button class="button is-primary" @click="setFilter">Найти</button></div>
                                <div class="control"><button class="button is-defult" @click="clearFilter">Сброс</button></div>                               
                            </div>

                            
                        </div>                        
                    </div>

                    <div class="field"><div class="control">
                        <div id="paginator" class="button" style="margin: 0 1rem; white-space: nowrap"></div>
                    </div></div>


                </div>
            </div>
        </div>

        
    </div>

<div class="level"> {{getDescription}} </div>
    
        <!--<input class="input is-primary" type="text" v-bind:value="catalogId" @click="$emit('loadCatalog')"/>-->
    

    <div id="catalogViewer" class="unselectable"></div>

    </div>
</template>





<script>
import _ from 'lodash'
import router from 'vue-router'
import {projectTypes} from '@/repository/projectTypes.js'
let catURLS = [];
    catURLS.push('/data/jrecords.json');
    catURLS.push('/data/jrecords.json');
    catURLS.push('/data/jrecords.json');
    catURLS.push('/data/jrecords.json');
export default {    
    name: "catalogViewer",
    props: { catalogId:{ Type: Number, default: 1 } },
    data () {
        return{
            Id: 1,
            selectedId: 1,
            catalogObj: null,
            catalogTitle: '',
            tableViewer: null,
            tableData: [],            
            dataLoading: true,
            filterField: 'title',
            filterQuery: '',
        }        
    },

    computed:{
       // dataStatus(){ return 'данные не загружены' },
       getFilter(){return filterField},
       // catid() {return this.catId }
       getCatalogTitle(){
            return this.catalogObj.title;
       },
       getDescription(){
           if (this.catalogObj) {return this.catalogObj.description;}
       }
    },

    created(){
       console.log('viewer created: ' + this.catalogId);
       this.selectedId = this.catalogId;
       let catId = parseInt(this.selectedId);
       console.dir(catId);
       this.catalogObj = _.find(projectTypes, {id:catId});   //this.catalogId              
       this.catalogTitle = this.catalogObj.title; 
       console.log(this.catalogTitle);
       //this.dataStatus = 'Загрузка данных';
       //console.dir( _.find(projectTypes, {id:this.props.catalogId}).gridHeader );       
       //this.loadCatalog();
       //console.dir(this.tableData);
    },

    methods:{        
        setFilter(){            
            if (this.tableViewer) {
                 this.tableViewer.setFilter( this.filterField, 'like', this.filterQuery  );
                 console.log(this.filterField, 'like', this.filterQuery)
             } 
        },
        clearFilter(){            
            if (this.tableViewer) { this.tableViewer.clearFilter(); } 
            this.filterQuery = '';
        },
        
        loadHeaders(){
                let selectedId = parseFloat(this.selectedId);
                this.catalogObj = _.find(projectTypes, {id:selectedId});
                console.log('replacing headers: ' + selectedId);
                console.dir(this.catalogObj);
//            if (this.tableViewer <> null) {
                let columns = this.catalogObj.gridHeader;
                this.tableViewer.setColumns( columns );
                
                console.dir(this.catalogObj.gridHeader);
//            }
        },        
        selectCatalog (){
            //this.tableViewer.clearData;
            console.log('selecting catalog');
            this.loadHeaders();
            this.loadCatalog();
            router.push({ name: 'catalog', params: { id: this.selectedId } });
            //router.push({ path: 'catalog/' + this.selectedId } );
        },
        loadCatalog(){
            console.log('load catalog: ' + this.selectedId);
            //if (!this.catalogId) this.catalogId = 1;
            //let url = 'http://localhost:8080/data/jrecords.json';
            let url = this.catalogObj.dataUrl; // 'http://localhost:8080/data/jrecords.json';
            //let url = catURLS[this.catalogId]; //'http://localhost:8080/data/jrecords.json';
            axios.get(url).then(data => { 
//              console.log('URL:' + url);
///              console.dir(data.data);
//              console.log('loaded: ' + data.data.length + 'rows');
              this.tableData = data.data;
              console.dir(this.tableData);
              this.tableViewer.replaceData(this.tableData);
          } )
          .catch(error => {console.log(error) } ); 
        }
    },

    beforeMount() {
       console.dir('viewer before mount');
//       console.dir(projectTypes);
//       let catId = parseInt(this.catalogId);
//       console.dir(catId);
//       this.catalogObj = _.find(projectTypes, {id:catId});   //this.catalogId       
       //setTimeout(200);
       console.dir(this.catalogObj);        
       this.loadCatalog();
    },

    mounted(){      
      //this.Id = this.catalogId;      
      const tableData = this.tableData;
      const paginator = document.querySelector("#paginator");
      console.log('viewer mounted');
      //console.dir( projectTypes );
      const catalogId = this.catalogId;
      const tableHeader =  this.catalogObj.gridHeader;
      console.dir(this.tableData);      
      this.tableViewer = new Tabulator('#catalogViewer', {
        //data: this.tableData, //link data to table
        //data: aData, //link data to table
        //placeholder:"Данные не загружены",
        data: tableData,
        placeholder: this.dataStatus,
        groupToggleElement:"header",
        columnAlign:"left", 
        layout:"fitData",        
        selectable: "highlight",
        pagination:"local",
        paginationSize:15,
        paginationElement:paginator,
        locale:true,
        columns: tableHeader
//        columns: [
          //{ title: "Шифр", field:"cipher", width:70, align:"center", headerSort:false },          
//          { title:"Наименование", field:"title",  width:"600", align:"left", headerSort:false, formatter:"textarea"},
//          ],
        },               
     );
      this.tableViewer.setLocale('ru');
      //this.loadCatalog();
      

    }


}
</script>


<style>
 #catalogViewer{width: auto; margin: 0 auto;
  display: block;
  position: relative;
  height: calc(100vh - 13rem) !important;
}

.field.is-horizontal {
    vertical-align: middle;
    align-items: center;
    place-items: center;
}

.tabulator-header{margin-left: 0px !important;
    font-weight: 400;
    font-size: .9rem;
}
.tabulator-tableHolder::-webkit-scrollbar:hover {
    background: rgba(0,0,0,.2);
    -webkit-transition: all .2s ease;
    transition: all .2s ease;
}
.tabulator-tableHolder::-webkit-scrollbar-thumb {
    cursor: pointer;
    border-radius: 8px;
    background: rgba(0,0,0,.25);
    -webkit-transition: all .2s ease;
    transition: all .2s ease
}

.tabulator-tableHolder::-webkit-scrollbar {
  width: 7px;
  height: 6px;
  background: rgba(0,0,0,.1);
    -webkit-transition: all .2s ease;
    transition: all .2s ease
}

 *.unselectable {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently */
    }
</style>
